<template>
  <div class="ac-body-container">
    <div class="ac-content-container">
      <div class="header">
        Subscribe to offline member reports
      </div>
      <div class="sub-header">
        When subscribed, recipients receive offline reports every 2 weeks:
      </div>
      <div class="input-container">
        <SACRadio
          name="subscribe"
          field="offlineReport"
          :value="true"
          :checked="subscribe"
          :change="onChange"
          label="Yes"
          :disable="adminRole !== 'admin'"
        />
        <div
          v-if="adminRole === 'admin' && subscribe"
          class="mt-2 margin-left-8"
        >
          <RecipientSetting
            :recipients="recipients"
            :email="email"
            :addEmail="addEmail"
            :removeEmail="removeEmail"
            :onChange="onChange"
            :errorObj="errorObj"
          />
        </div>
      </div>
      <SACRadio
        name="subscribe"
        field="offlineReport"
        :value="false"
        :checked="subscribe === false"
        :change="onChange"
        label="No"
        :disable="adminRole !== 'admin'"
      />
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';
import SACRadio from '@shared/components/sac/SACRadio.vue';
import RecipientSetting from './shared/RecipientSetting.vue';

export default {
  name: 'OfflineReport',
  components: {
    RecipientSetting,
    SACRadio,
  },
  mixins: [partnerSettingsMixin],
  props: {
    subscribe: Boolean,
    recipients: Array,
    email: String,
    addEmail: Function,
    removeEmail: Function,
    onChange: Function,
    errorObj: Object,
  },
};
</script>

<style lang="scss" scoped>

.input-container {
  width: 60%;
}
.header {
  font-size: 1rem;
  font-weight: 700;
  color: $N80;
}
.sub-header {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
}
.ac-content-container {
  &:not(:last-child) {
    padding-bottom: 18px;
    margin-bottom: 18px;
    border-bottom: 2px solid $N20;
  }
}
.ac-input-container, .sac-radio-container {
  margin-top: 12px;
  margin-bottom: 0 !important;
}
.body {
  font-size: 0.875rem;
  margin-top: 8px;
  margin-bottom: 8px;
  color: $N80;
}
.sub-label {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
  max-width: 600px;
}
</style>
